import { SideswipeFooter } from "@wf-components/footer-react";

// Accepts the runtime locale string ("en", "de", "es-es", …). The downstream
// SideswipeFooter web component types its locale prop as `string`, so we don't
// re-narrow to the Hygraph Locale enum here — Hygraph's enum values use
// underscores ("es_ES") whereas runtime locales use hyphens ("es-es"), and
// casting between the two is a lying cast that hid the mismatch.
export const Footer = ({ locale, domain }: { locale: string; domain: string | undefined }) => {
	return (
		<SideswipeFooter
			locale={locale}
			domain={domain}
			disableNewsletter={false}
			// Locale switcher links: route through `?setlang=` so the server-side
			// `handleUrlRedirect` writes the EPIC_LOCALE cookie and strips the
			// param. Without this override the web component falls back to its
			// default `?lang=<locale>` template, which is the legacy transient-
			// signal form — `?lang` is read but never persists the cookie, so
			// the user's choice doesn't stick across navigations. Mirrors
			// rocketleague.com's Footer/Navbar config.
			localeHrefTemplate="{domain}/?setlang={locale}"
		/>
	);
};
